import { Controller } from "@hotwired/stimulus";

/* 出金申請履歴ページ用 */
export class PayoutHistoriesController extends Controller {

  connect() {
    // キャンセルボタンを持つフォームが送信されたときの処理を登録
    this.element.querySelectorAll("form:has(button[aria-label='申請をキャンセル'])").forEach(form => {
      form.addEventListener("submit", this.submit)
    })
  }

  disconnect() {
    this.element.querySelectorAll("form:has(button[aria-label='申請をキャンセル'])").forEach(form => {
      form.removeEventListener("submit", this.submit)
    })
  }

  //
  submit(event) {
    if (!confirm("出金申請をキャンセルします。\nよろしいですか？")) {
      event.preventDefault();
    }
  }
}
